import { createSlice } from '@reduxjs/toolkit';
import { uiInitialState as initialState } from '../initialStates/uiInitialState';

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebar(state, action) {
      state.sidebarCollapsed = !!action.payload;
    }
  }
});

export const { toggleSidebar, setSidebar } = uiSlice.actions;
export default uiSlice.reducer;
